import styled from 'styled-components';

import { screenReaderOnly } from 'utils/style/screen-reader-only';

const VisuallyHidden = styled.span`
  ${screenReaderOnly}
`;

export default VisuallyHidden;
